import { createAction, props } from '@ngrx/store';
import { Movie } from '../../models/movie';

export const Test9ActionTypes = {
  loadMovies: '[Test9] Load Movies',
  loadMoviesSuccess: '[Test9] Load Movies Success',
  loadMoviesFailure: '[Test9] Load Movies Failure',

  addMovie: '[Test9] add Movies',
  addMovieSuccess: '[Test9] add Movies Success',
  addMovieFailure: '[Test9] add Movies Failure',

  updateMovie: '[Test9] update Movies',
  updateMovieSuccess: '[Test9] update Movies Success',
  updateMovieFailure: '[Test9] update Movies Failure',

  deleteMovie: '[Test9] delete Movies',
  deleteMovieSuccess: '[Test9] delete Movies Success',
  deleteMovieFailure: '[Test9] delete Movies Failure',

}

//---------------------LOAD----------------
export const loadMovies = createAction(
  Test9ActionTypes.loadMovies
);

export const loadMoviesSuccess = createAction(
  Test9ActionTypes.loadMoviesSuccess,
  // props<{ data: any }>()
  (data: any) => ( data )
);

export const loadMoviesFailure = createAction(
  Test9ActionTypes.loadMoviesFailure,
  props<{ error: any }>()
);

//---------------------ADD--------------------

export const addMovie = createAction(
  Test9ActionTypes.addMovie,
  //props<{ data: Movie }>()
  (movie: Movie) => ( movie )
);

export const addMovieSuccess = createAction(
  Test9ActionTypes.addMovieSuccess,
  props<{ data: any }>()
  //(movie: Movie) => ( movie )
);

export const addMovieFailure = createAction(
  Test9ActionTypes.addMovieFailure,
  props<{ error: any }>()
);

//---------------------UPDATE--------------

export const updateMovie = createAction(
  Test9ActionTypes.updateMovie,
  //props<{ data: Movie }>()
  (movie: Movie) => (movie)
);

export const updateMovieSuccess = createAction(
  Test9ActionTypes.updateMovieSuccess,
  props<{ data: any }>()
  //(movie: Movie) => ( movie )
);

export const updateMovieFailure = createAction(
  Test9ActionTypes.updateMovieFailure,
  props<{ error: any }>()
);

//---------------------Delete--------------

export const deleteMovie = createAction(
  Test9ActionTypes.deleteMovie,
  props<{ movieId: number }>()
    //(movie: Movie) => (movie)
  // (movieId: any) => (movieId)
);

export const deleteMovieSuccess = createAction(
  Test9ActionTypes.deleteMovieSuccess,
  props<{ data: any }>()
  //(movie: Movie) => ( movie )
);

export const deleteMovieFailure = createAction(
  Test9ActionTypes.deleteMovieFailure,
  props<{ error: any }>()
);
